import React from 'react';

export default (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="953.665"
    height="127.708"
    viewBox="0 0 953.665 127.708"
  >
    <g
      id="recipe_box_logo"
      data-name="recipe box logo"
      transform="translate(-53.595 -57.931)"
    >
      <path
        id="Path_243"
        data-name="Path 243"
        d="M0,0V27.469l30.971,17.42L0,62.315v65.393H85.982l31.834-17.91.333-.189V18.093L85.982,0ZM7.246,7.246H79.212V20.491H7.246ZM79.212,120.462H7.246V69.294H79.212v51.168Zm6.423-58.421H13.708l18.8-10.579h71.927ZM110.9,106.25,86.465,120V69.019L110.9,55.272Zm.392-61.695L41.08,44.223l-27.5-16.479H85.635l25.653,14.525v2.287ZM86.465,7.71,110.9,21.458V34.506L86.465,20.759V7.71Z"
        transform="translate(53.595 57.931)"
        fill="#311917"
      />
      <path
        id="Path_244"
        data-name="Path 244"
        d="M290.53,104.67c0-16.66-12.74-30.24-30.52-30.24H218.15a2.658,2.658,0,0,0-2.66,2.66v92.68a2.658,2.658,0,0,0,2.66,2.66h16.66a2.754,2.754,0,0,0,2.66-2.66v-35.7h9.66l18.62,37.1a2.577,2.577,0,0,0,2.24,1.26h18.62a2.649,2.649,0,0,0,2.38-4.06l-19.18-35.56C282.83,127.91,290.53,117.55,290.53,104.67Zm-32.34,11.62H237.47V94.45h20.72a10.292,10.292,0,0,1,10.64,10.64C268.83,111.67,263.93,116.29,258.19,116.29Z"
        fill="#311917"
      />
      <path
        id="Path_245"
        data-name="Path 245"
        d="M370.19,74.43H312.23a2.658,2.658,0,0,0-2.66,2.66v92.68a2.658,2.658,0,0,0,2.66,2.66h57.96a2.658,2.658,0,0,0,2.66-2.66V154.51a2.658,2.658,0,0,0-2.66-2.66H331.41v-18.9h31.92a2.658,2.658,0,0,0,2.66-2.66V115.03a2.754,2.754,0,0,0-2.66-2.66H331.41V95.01h38.78a2.658,2.658,0,0,0,2.66-2.66V77.09A2.658,2.658,0,0,0,370.19,74.43Z"
        fill="#311917"
      />
      <path
        id="Path_246"
        data-name="Path 246"
        d="M435.99,94.17a27.564,27.564,0,0,1,18.9,7.14,2.451,2.451,0,0,0,3.5,0l10.92-11.34a2.6,2.6,0,0,0-.14-3.92c-9.52-8.68-19.88-13.02-33.88-13.02a50.4,50.4,0,1,0,0,100.8,48.05,48.05,0,0,0,34.02-13.58,2.8,2.8,0,0,0,.14-3.78l-10.92-11.62a2.767,2.767,0,0,0-3.64-.14,27.461,27.461,0,0,1-18.76,6.72c-15.82,0-27.58-12.88-27.58-28.42C408.55,107.33,420.17,94.17,435.99,94.17Z"
        fill="#311917"
      />
      <path
        id="Path_247"
        data-name="Path 247"
        d="M506.27,74.43h-16.8a2.754,2.754,0,0,0-2.66,2.66v92.68a2.754,2.754,0,0,0,2.66,2.66h16.8a2.754,2.754,0,0,0,2.66-2.66V77.09A2.754,2.754,0,0,0,506.27,74.43Z"
        fill="#311917"
      />
      <path
        id="Path_248"
        data-name="Path 248"
        d="M568.85,74.43H535.11a2.658,2.658,0,0,0-2.66,2.66v92.68a2.658,2.658,0,0,0,2.66,2.66h16.52a2.754,2.754,0,0,0,2.66-2.66v-32.9h14.7c18.34,0,31.22-14.14,31.22-31.5C600.21,88.43,587.33,74.43,568.85,74.43Zm-.42,42H554.29V95.01h14.14a9.967,9.967,0,0,1,10.22,10.36C578.65,111.67,574.45,116.43,568.43,116.43Z"
        fill="#311917"
      />
      <path
        id="Path_249"
        data-name="Path 249"
        d="M676.36,74.43H618.4a2.658,2.658,0,0,0-2.66,2.66v92.68a2.658,2.658,0,0,0,2.66,2.66h57.96a2.658,2.658,0,0,0,2.66-2.66V154.51a2.658,2.658,0,0,0-2.66-2.66H637.58v-18.9H669.5a2.658,2.658,0,0,0,2.66-2.66V115.03a2.754,2.754,0,0,0-2.66-2.66H637.58V95.01h38.78a2.658,2.658,0,0,0,2.66-2.66V77.09A2.658,2.658,0,0,0,676.36,74.43Z"
        fill="#311917"
      />
      <path
        id="Path_250"
        data-name="Path 250"
        d="M782.48,122.59v-.14c7.98-3.22,15.96-10.78,15.96-21.98,0-14.7-13.58-26.04-30.1-26.04H735.72a2.658,2.658,0,0,0-2.66,2.66v92.68a2.658,2.658,0,0,0,2.66,2.66h34.72c16.66,0,30.52-10.5,30.52-27.02C800.96,131.83,791.02,125.39,782.48,122.59Zm-27.58-28h11.62c5.32,0,9.1,3.92,9.1,9.52s-3.78,10.08-9.1,10.08H754.9Zm11.9,57.82H754.9V132.39h12.18c6.86,0,10.64,4.34,10.64,9.94C777.72,148.91,773.8,152.41,766.8,152.41Z"
        fill="#311917"
      />
      <path
        id="Path_251"
        data-name="Path 251"
        d="M864.52,73.03a50.4,50.4,0,1,0,50.4,50.54A50.191,50.191,0,0,0,864.52,73.03Zm0,78.4a28,28,0,1,1,28-27.86A28.024,28.024,0,0,1,864.52,151.43Z"
        fill="#311917"
      />
      <path
        id="Path_252"
        data-name="Path 252"
        d="M1006.76,168.51l-29.4-46.34,28.42-43.82c1.26-1.82,0-3.92-2.38-3.92H982.96a2.782,2.782,0,0,0-2.24,1.26l-16.38,26.04h-.14L948.1,75.69a3.02,3.02,0,0,0-2.24-1.26H925.42c-2.38,0-3.5,2.1-2.38,3.92l28.28,43.82-29.4,46.34c-1.26,1.82,0,3.92,2.38,3.92h19.46a3.067,3.067,0,0,0,2.38-1.26l17.92-28.28h.28l18.34,28.28a3.118,3.118,0,0,0,2.38,1.26h19.46C1006.76,172.43,1008.02,170.47,1006.76,168.51Z"
        fill="#311917"
      />
    </g>
  </svg>
);
